import { SharedModule } from './../../shared/shared.module';
import { NgModule } from '@angular/core';
import { ServicosComponent } from './servicos.component';
import { ServicosRoutingModule } from './servicos-routing.module';
import { ServiceFormComponent } from './service-form/service-form.component';

@NgModule({
  declarations: [ServicosComponent, ServiceFormComponent],
  imports: [
    SharedModule,
    ServicosRoutingModule
  ]
})
export class ServicosModule { }
